import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, type ResponseError } from '../utils'

export const TemplateFlag = {
  ApplicationAccepted: 1,
  ApplicationRefused: 2,
  ApplicationIntegrated: 3
} as const

export type TemplateFlagValue = (typeof TemplateFlag)[keyof typeof TemplateFlag]

type EmailTemplate = {
  id: number
  name: string
  subject: string
  content: string
  flag: TemplateFlagValue | null
}

export const useEmailTemplates = () =>
  useQuery<EmailTemplate[], ResponseError>({
    queryKey: ['emails', 'templates'],
    queryFn: () =>
      fetchApiWithToken<EmailTemplate[]>({
        method: 'get',
        url: '/v1/templates?itemsPerPage=999'
      }),
    refetchOnWindowFocus: false,
    staleTime: 1800_000
  })

export type EmailTemplateAttachment = {
  id: number
  object: {
    id: number
    uri: string
    filename: string | null
    size: number | null
  }
}

export const useEmailTemplateAttachments = (templateId?: number | null) =>
  useQuery<EmailTemplateAttachment[], ResponseError>({
    queryKey: ['emails', 'templates', templateId, 'attachments'],
    queryFn: () =>
      fetchApiWithToken<EmailTemplateAttachment[]>({
        method: 'get',
        url: `/v1/templates/${templateId}/attachments`
      }),
    refetchOnWindowFocus: false,
    enabled: !!templateId,
    staleTime: 1800_000
  })
